<template>
    <div class="add-services" >
        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
             <van-cell>
                   领药人
            </van-cell>
            <van-cell>
                <van-checkbox v-model="allchecked" @click="toggleAll()">全选</van-checkbox>
            </van-cell>
            <van-checkbox-group v-model="predict_ids" ref="checkboxGroup">
                <van-cell v-for="item,index in items" :key="index">
                    <van-checkbox :name="item.id">{{item.name}}</van-checkbox>
                </van-cell>
            </van-checkbox-group>
        </van-cell-group>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';
    import { 
      getDrugstorePredictAll,
  } from '@/api/publicWelfareStaff' 
  Vue.use(Toast);
export default {
	data(){
		return {
            allchecked:false,
            //领药人
            predict_ids:[],

            items:[],

		}
	},
	async created() {
        if(this.publicWelfareStaff.predict_ids){
            this.publicWelfareStaff.predict_ids.forEach(ele=>{
                this.predict_ids.push(ele.id)
            })
        }
        await this.getData()
        // this.checkIfAll()
	},
    computed:{
        ...mapState(['publicWelfareStaff']),
    },
	methods:{
        checkIfAll(){
            let item=[]
            this.items.forEach(ele=>{
                item.push(ele.id)
            })
            if(this.predict_ids==item) this.allchecked=true
        },
        toggleAll() {
            if(!this.allchecked) {
                this.$refs.checkboxGroup.toggleAll(false);
            }else{
                 this.$refs.checkboxGroup.toggleAll(true);
            }
        },
        async getData(){
            //获取省份
            await getDrugstorePredictAll({ 
                drugstore_id:this.$route.query.drugstore_id
            }).then(res => {
                this.items=[]
                let items=[]
                if(res.data){
                    res.data.forEach(ele=>{
                        items.push({
                            name:ele.patient.name,
                            id:ele.id
                        })
                    })
                    this.items=items
                    console.log("this.items",this.items)
                }
            })
        },
    },
    beforeDestroy(){
        console.log("predict_ids",this.predict_ids)
        let saveData = []
        this.items.forEach(ele=>{
            this.predict_ids.forEach(id=>{
                if(id==ele.id) saveData.push(ele)
            })
        })
        this.$store.commit('setPredict_ids',saveData)
    }
};
</script>

<style lang="less" scoped>
.add-services {
	font-size: 16px;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding-top: 15px;
    .group2{
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value{
            flex:1.5 0 !important;
        }
        
    }
	.checkin-btn {
      margin: 25px;
    }
    /deep/ .noborder.van-cell::after{
      border-bottom:none !important;
    }



    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
    ::v-deep .grey-label{
        color:#9D9D9D;
        white-space:nowrap;
    }
}
</style>